import React from "react";

import type { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { TableHeader } from "../../../commons";
import InfiniteLoader from "../../../commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../../commons/ScrollToTop";
import BOMSavedTemplateTableData from "./BOMSavedTemplateTableData";

type AppProps = {
  data: any[];
  headers: TableHeadersType[];
  fetching: boolean | undefined;
  handleBOMSavedTemplateView?: (data: any) => void;
  offset: number;
  type: string;
};

const BOMSavedTemplateTable = ({
  data,
  headers,
  fetching,
  offset,
  type,
  handleBOMSavedTemplateView,
}: AppProps) => {
  return (
    <div className="jobsType table-responsive">
      <table className="table table-bordered thead-light">
        <thead className="text-start sticky-table-header">
          <TableHeader tableHeader={headers} />
        </thead>
        <tbody>
          <BOMSavedTemplateTableData
            data={data}
            type={type}
            tableHeader={headers}
            handleBOMSavedTemplateView={handleBOMSavedTemplateView}
          />
          <div style={{ display: fetching ? "none" : "inline" }}>
            <ScrollToTop />
          </div>
          {fetching && offset && offset > 0 && <div>{<InfiniteLoader />}</div>}
        </tbody>
      </table>
    </div>
  );
};

export default BOMSavedTemplateTable;
